import { render, staticRenderFns } from "./ZimmerBelegung.vue?vue&type=template&id=458f6789"
import script from "./ZimmerBelegung.vue?vue&type=script&lang=js"
export * from "./ZimmerBelegung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports